const setChatTabStyles = (root, chatTab) => {
    root.documentElement.style.setProperty('--height', chatTab.height);
    root.documentElement.style.setProperty(
        '--backgroundAnimateColor',
        chatTab.backgroundAnimateColor
    );
    root.documentElement.style.setProperty('--backgroundColor', chatTab.backgroundColor);
    root.documentElement.style.setProperty('--hoverColor', chatTab.hoverColor);
    root.documentElement.style.setProperty('--textColor', chatTab.textColor);
    root.documentElement.style.setProperty('--fontSize', chatTab.fontSize);
    root.documentElement.style.setProperty('--fontWeight', chatTab.fontWeight);
    root.documentElement.style.setProperty('--fontFamily', chatTab.fontFamily);
    root.documentElement.style.setProperty('--borderColor', chatTab.borderColor);
    root.documentElement.style.setProperty('--borderWidth', chatTab.borderWidth);
    root.documentElement.style.setProperty('--italic', chatTab.italic);
    root.documentElement.style.setProperty('--bold', chatTab.bold);
    root.documentElement.style.setProperty('--underline', chatTab.underline);
    root.documentElement.style.setProperty('--borderRadius', chatTab.borderRadius);
};
export default setChatTabStyles;
